import { lazy, Suspense } from 'react'
import { createBrowserRouter } from 'react-router-dom'
import { workinprogressIcon as WorkInProgressIcon } from '@/assets/svgIcons'
import Card from '@/components/atom/card/card'
import { ErrorBoundary } from 'react-error-boundary'
// const Overview = lazy(
//   () =>
//     import('@/containers/TechnologyAndNetwork/siteDetails/Overview/overview'),
// )
const Overview = lazy(
  () =>
    import(
      '@/containers/TechnologyAndNetwork/siteDetails/Overview/newOverview'
    ),
)
const DeviceInventory = lazy(
  () =>
    import(
      '@/containers/TechnologyAndNetwork/siteDetails/deviceInventory/deviceInventory'
    ),
)
const NodeDetails = lazy(
  () =>
    import(
      '@/containers/TechnologyAndNetwork/siteDetails/deviceInventory/nodeDetails'
    ),
)

const OrderManagement = lazy(
  () => import('@/containers/Orders/orderManagement'),
)
const ResponsiveDashboard = lazy(
  () => import('@/containers/Dashboard/dashboard/responsiveDashboard'),
)
const ProjectOverview = lazy(
  () => import('@/containers/Overview/ProjectOverview/ProjectOverview'),
)
const Orders = lazy(() => import('@/containers/Orders/orders'))
const ServiceDeliverySites = lazy(
  () => import('@/containers/Orders/services/serviceDeliverySites'),
)
const Users = lazy(() => import('@/containers/UsersAndGroups/users/users'))
import SomethingWentWrong from '@/components/atom/somethingWentWrong/somethingWentWrong'

const ProtectedRoute = lazy(() =>
  import('@/routes/protected/protectedRoute').then(module => ({
    default: module.ProtectedRoute,
  })),
)
const Layout = lazy(() =>
  import('@/routes/layout/layout').then(module => ({
    default: module.Layout,
  })),
)
const NotFound = lazy(() =>
  import('@/routes/notFound/notFound').then(module => ({
    default: module.NotFound,
  })),
)

const UnAuthorized = lazy(
  () => import('@/components/atom/unAuthorized/unAuthorized'),
)

const Login = lazy(() => import('@/containers/login/login'))
const CaseManagement = lazy(
  () => import('@/containers/CaseManagement/caseManagement'),
)
const CasesTable = lazy(
  () => import('@/containers/CaseManagement/casesTable/CasesTable'),
)
// const CreateCases = lazy(
//   () => import('@/containers/CaseManagement/createCasesOld'),
// )
const CreateCases = lazy(() => import('@/containers/CaseManagement/createCase'))
const CaseDetails = lazy(
  () => import('@/containers/CaseManagement/caseDetails/CaseDetails'),
)
const SiteDetails = lazy(
  () =>
    import(
      '@/containers/TechnologyAndNetwork/siteDetails/siteDetailsData/siteDetails'
    ),
)
const BillingAndUsageExpanded = lazy(
  () =>
    import(
      '@/containers/BillingAndUsage/billingAndUsageExpanded/billingAndUsageExpanded'
    ),
)
const BillingService = lazy(
  () => import('@/containers/BillingAndUsage/serviceBillings/serviceBillings'),
)
const Sites = lazy(
  () => import('@/containers/TechnologyAndNetwork/siteList/sites'),
)
const SiteTable = lazy(
  () => import('@/containers/TechnologyAndNetwork/siteList/siteTable'),
)
const Bills = lazy(() => import('@/containers/BillingAndUsage/Bills/Bills'))

const PaymentMethods = lazy(
  () => import('@/containers/BillingAndUsage/payments/payments'),
)
const WikiChatbot = lazy(() => import('@/containers/Wiki/WikiChatbot'))

// const VisioLayout = lazy(() => import('../layout/visioLayout'))
const ActiveServicesExpanded = lazy(
  () =>
    import(
      '@/containers/TechnologyAndNetwork/siteDetails/ActiveService/ActiveServicesExpanded'
    ),
)
const RecentAlertsExpanded = lazy(
  () =>
    import(
      '@/containers/TechnologyAndNetwork/siteDetails/RecentAlerts/recentAlertsExpanded'
    ),
)

const OrderDetails = lazy(
  () => import('@/containers/Orders/views/details/orderDetails'),
)
// const Orders = lazy(() => import('@/containers/Orders/orders'))
const Reports = lazy(
  () => import('@/containers/AnalyticsAndReports/reports/reports'),
)
const RunReports = lazy(
  () => import('@/containers/AnalyticsAndReports/reports/runReports'),
)
const ScheduledReports = lazy(
  () => import('@/containers/AnalyticsAndReports/reports/scheduledReports'),
)
const ReportByCategory = lazy(
  () => import('@/containers/AnalyticsAndReports/reports/reportByCategory'),
)
const WorkInProgress = () => (
  <LazyLoadWrapper height='100%' width='100%'>
    <Card className='w-full justify-center px-6 pt-4 pb-6 flex flex-col gap-3'>
      <div className='w-[calc(100%-12px)] h-[calc(100vh-110px)] flex justify-center items-center'>
        <WorkInProgressIcon />
      </div>
    </Card>
  </LazyLoadWrapper>
)

const Placeholder = ({ height, width }: { height: string; width: string }) => (
  <div
    style={{ height, width }}
    className='bg-primary rounded-radius-md animate-pulse'
  />
)

const LazyLoadWrapper = ({
  children,
  height,
  width,
}: {
  children: React.ReactNode
  height: string
  width: string
}) => (
  <Suspense
    fallback={
      <div style={{ height, width }}>
        <Placeholder height={height} width={width} />
      </div>
    }
  >
    {children}
  </Suspense>
)

const routes = [
  {
    path: '/',
    element: <Login />,
  },
  {
    element: (
      <ErrorBoundary fallback={<SomethingWentWrong />}>
        <LazyLoadWrapper height='100%' width='100%'>
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        </LazyLoadWrapper>
      </ErrorBoundary>
    ),
    children: [
      {
        path: '/home',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <ResponsiveDashboard />
          </LazyLoadWrapper>
        ),
      },
      {
        path: '/wiki',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <WikiChatbot />
          </LazyLoadWrapper>
        ),
      },
      {
        path: 'wiki',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <WikiChatbot />
          </LazyLoadWrapper>
        ),
      },
      {
        path: '/userandgroups/users',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <Users />
          </LazyLoadWrapper>
        ),
      },
      {
        path: '/support/casemanagement',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <CaseManagement />
          </LazyLoadWrapper>
        ),
        key: 'casemanagement',
        children: [
          {
            element: <CasesTable />,
            key: 'case-table',
            index: true,
          },
          {
            path: 'create',
            element: <CreateCases />,
            key: 'create-case',
          },
          {
            path: ':caseId',
            element: <CaseDetails />,
            key: 'case-detail',
          },
        ],
      },
      {
        path: '/technologyandnetworks/sitepage',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <SiteDetails />
          </LazyLoadWrapper>
        ),
        children: [
          {
            element: (
              <LazyLoadWrapper height='100%' width='100%'>
                <Overview />
              </LazyLoadWrapper>
            ),
            key: 'site-overview',
            index: true,
          },
          {
            path: 'devices',
            element: (
              <LazyLoadWrapper height='100%' width='100%'>
                <DeviceInventory />
              </LazyLoadWrapper>
            ),
            key: 'site-devices',
          },
        ],
      },
      {
        path: '/technologyandnetworks/activeservices',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <DeviceInventory />
          </LazyLoadWrapper>
        ),
      },

      {
        path: '/technologyandnetworks/activeservices/:nodeIpAddress',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <NodeDetails />
          </LazyLoadWrapper>
        ),
      },
      {
        path: '/billingandusage/overview',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <BillingAndUsageExpanded />
          </LazyLoadWrapper>
        ),
      },
      {
        path: '/billingandusage/servicebilling',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <BillingService />
          </LazyLoadWrapper>
        ),
      },
      {
        path: '/billingandusage/bills',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <Bills />
          </LazyLoadWrapper>
        ),
      },
      {
        path: '/billingandusage/payments',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <PaymentMethods />
          </LazyLoadWrapper>
        ),
      },
      {
        path: '/technologyandnetworks/serviceinventory',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <ActiveServicesExpanded />
          </LazyLoadWrapper>
        ),
      },

      {
        path: '/technologyandnetworks/sitepage/alerts',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <RecentAlertsExpanded />
          </LazyLoadWrapper>
        ),
      },
      {
        path: '/service-delivery/sites',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <ServiceDeliverySites />
          </LazyLoadWrapper>
        ),
      },
      {
        path: '/service-delivery/orders',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <OrderManagement />
          </LazyLoadWrapper>
        ),
        key: 'orders',
        children: [
          {
            element: (
              <LazyLoadWrapper height='100%' width='100%'>
                <Orders />
              </LazyLoadWrapper>
            ),
            key: 'order-detail',
            index: true,
          },
          {
            path: ':orderId',
            element: <OrderDetails />,
            key: 'order-detail',
          },
        ],
      },

      {
        path: '/usersandgroups/users',
        element: <WorkInProgress />,
      },

      {
        path: '/service-delivery/overview',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <ProjectOverview />
          </LazyLoadWrapper>
        ),
      },

      {
        path: '/siteusers',
        element: <WorkInProgress />,
      },
      {
        path: '/technologyandnetworks/sitelist',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <Sites />
          </LazyLoadWrapper>
        ),
        key: 'sites',
        children: [
          {
            element: <SiteTable />,
            index: true,
            key: 'site-table',
          },
          {
            path: '/technologyandnetworks/sitelist/:siteId',
            element: <SiteDetails />,
            key: 'site-detail',
          },
        ],
      },
      {
        path: '/technologyandnetworks/sdwan',
        element: <WorkInProgress />,
      },
      {
        path: '/technologyandnetworks/security',
        element: <WorkInProgress />,
      },
      {
        path: '/technologyandnetworks/switching',
        element: <WorkInProgress />,
      },
      {
        path: '/technologyandnetworks/wireless',
        element: <WorkInProgress />,
      },
      {
        path: '/technologyandnetworks/voice',
        element: <WorkInProgress />,
      },
      {
        path: '/analyticsandreports/monitor',
        element: <WorkInProgress />,
      },
      {
        path: '/analyticsandreports/reports',
        element: (
          <LazyLoadWrapper height='100%' width='100%'>
            <Reports />
          </LazyLoadWrapper>
        ),
        key: 'reports',
        children: [
          {
            element: <RunReports />,
            index: true,
            key: 'report-table',
          },
          {
            element: <ScheduledReports />,
            key: 'scheduled-reports',
            path: '/analyticsandreports/reports/scheduledreports',
          },
          {
            path: '/analyticsandreports/reports/:item',
            element: <ReportByCategory />,
            children: [
              {
                path: 'statement/:id',
                element: <ReportByCategory />,
              },
            ],
          },
          {
            path: '/analyticsandreports/reports/:item',
            element: <ReportByCategory />,
            key: 'usage-by-id',
          },
        ],
      },
      {
        path: '/usersandgroups/groups',
        element: <WorkInProgress />,
      },
      {
        path: '/usersandgroups/roles',
        element: <WorkInProgress />,
      },
      {
        path: '/helpandfeedback',
        element: <WorkInProgress />,
      },
      {
        path: '/settings',
        element: <WorkInProgress />,
      },
    ],
  },
  // {
  //   element: (
  //     <LazyLoadWrapper height='100%' width='100%'>
  //       <VisioLayout />
  //     </LazyLoadWrapper>
  //   ),
  //   children: [
  //     {
  //       path: '/visiodata',
  //       element: <VisioData />,
  //     },
  //   ],
  // },
  {
    path: '/unauthorized',
    element: (
      <LazyLoadWrapper height='100%' width='100%'>
        <UnAuthorized />
      </LazyLoadWrapper>
    ),
    // element: <UnauthorizedPage />,
  },
  {
    path: '*',
    element: (
      <LazyLoadWrapper height='100%' width='100%'>
        <NotFound />
      </LazyLoadWrapper>
    ),
  },
]

export const router = createBrowserRouter(routes, {
  basename: '/app',
  future: {
    v7_relativeSplatPath: true, //To opt-in early to the v7 behavior (so your code doesn't break later), you can enable the future flag v7_relativeSplatPath when creating your router:
  },
})
